<button
  class="btn btn-primary d-flex align-items-center justify-content-center gap-2"
  [ngClass]="[signInClass() || '', isModal ? 'btn-block' : '']"
  (click)="login()"
>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 23 23" width="18" height="18" style="margin-right: 8px">
    <rect width="10" height="10" x="1" y="1" fill="#F25022" />
    <!-- Red -->
    <rect width="10" height="10" x="12" y="1" fill="#7FBA00" />
    <!-- Green -->
    <rect width="10" height="10" x="1" y="12" fill="#00A4EF" />
    <!-- Blue -->
    <rect width="10" height="10" x="12" y="12" fill="#FFB900" />
    <!-- Yellow -->
  </svg>

  <span translate>account.signin.azure.button.label</span>
</button>
